import './src/vaadin-dashboard.js';

export * from './src/vaadin-dashboard.js';
